import * as React from 'react';
import { SVGProps } from 'react';

const IconLightningBoltSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17 2H8L5 15l4.8-.8L7 24h.5L19 9l-5.867.733L17 2z" />
  </svg>
);
export default IconLightningBoltSizeM;
